import React, { useContext, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { AuthContext } from '../AuthContext';
import { ReactComponent as DashboardIcon } from '../../assets/svg/dashboard2.svg'
import { ReactComponent as SearchDocsIcon } from '../../assets/svg/search.svg'
import { ReactComponent as DocumentationIcon } from '../../assets/svg/documentation.svg'
import { ReactComponent as ACLIcon } from '../../assets/svg/acl.svg'
import { ReactComponent as AddresssIcon } from '../../assets/svg/address.svg'
import { Can } from '../../hooks/usePermissions';
import { checkIfActiveSidebar } from '../../commonfunctions';


const MilmaAdminSidebar = () => {
   
    const { user } = useContext(AuthContext); // Get user data from context
    const location = useLocation();
    console.log("location", location.pathname);
    
    const [activeNavs, setActiveNavs] = useState({ fin_account: false, link_to_store: false });
    const toggleActiveNav = (keyName) => {


        setActiveNavs({ ...activeNavs, [keyName]: activeNavs[keyName] ? false : true });

       

    };
    return (
        <>
            {/* Sidebar Start */}
     <div className="app-nav" id="app-simple-bar">
      <ul className="main-nav p-0 mt-2">
        {/* <li className="menu-title">
          <span>Docs Milma Cloud</span>
        </li> */}
      
      
        <li className={`no-sub ${checkIfActiveSidebar(['/milma-admin/home'],location)}`}>
          <Link to="/milma-admin/home" >
             <SearchDocsIcon/>
            Dashboard
          </Link>
        </li> 
        <li className={`no-sub ${checkIfActiveSidebar(['/milma-admin/franchisees'],location)}`}>
          <Link to="/milma-admin/franchisees" >
             <SearchDocsIcon/>
            Franchisees
          </Link>
        </li>


        {/* --- NEW: Visible ONLY to Global Admins --- */}
                    {user?.is_global_admin && (
                        <li className={`no-sub ${checkIfActiveSidebar(['/milma-admin/managers'],location)}`}>
                            <Link to="/milma-admin/managers" >
                                <AddresssIcon/>
                                Milma Admins
                            </Link>
                        </li>
                    )}

          <li >
                  <a className={`${checkIfActiveSidebar(['/milma-admin/roles','/milma-admin/permissions'],location)}`} aria-expanded="false" data-bs-toggle="collapse" href="#access-control">
                    <ACLIcon/>
                Access Control
                  </a>
                  <ul className="collapse" id="access-control">
                   
                  
        
                    <li><Link to="/milma-admin/roles">Roles</Link></li>
                    <li><Link to="/milma-admin/permissions">Permissions</Link></li>
                 
                   
        
                    
                    
                  </ul>
                </li>  

       

    
    
        
        
      </ul>
    </div>

        </>
    )
}

export default MilmaAdminSidebar
